import PropTypes from 'prop-types'
import PriceUtil from 'utils/price-util'

const CustomerCheckoutPrice = ({ price }) => {
  const displayPrice = price
    ? PriceUtil.formatToIDR(price)
    : 'IDR 0'

  return (
    <strong>
      { displayPrice }
    </strong>
  )
}

CustomerCheckoutPrice.propTypes = {
  price: PropTypes.number
}

CustomerCheckoutPrice.defaultProps = {
  price: 8888888
}

export default CustomerCheckoutPrice